"use server";
import { serverFetch, serverFetchText } from "@/lib";
import type {
  OrderDetailsType,
  OrderPreferencesType,
  OrderType,
  ProductOrdersType,
  ProductsSearchState,
  ProductType,
  SearchParams,
  UserOrdersType,
  UserPreferencesType,
  UsersSearchState,
  UserType,
} from "@/types";

export const getUsersTop = async (params: SearchParams) => {
  const path = process.env.API_REPORTS_USERS_TOP!;
  return await serverFetch<UserType[]>({ path, params });
};

export const getUserOrders = async (userId: string, params: SearchParams) => {
  const path = `${process.env.API_REPORTS_USERS!}/${userId}/orders`;
  return await serverFetch<UserOrdersType>({ path, params });
};

export const getOrderDetails = async (userId: string, orderId: string, params: SearchParams) => {
  const path = `${process.env.API_REPORTS_USERS!}/${userId}/orders/${orderId}/details`;
  return await serverFetch<OrderDetailsType>({ path, params });
};

export const getUsersPreferences = async (params: SearchParams) => {
  const path = process.env.API_REPORTS_USER_PREFERENCES!;
  return await serverFetch<UserPreferencesType>({ path, params });
};

export const getUserPreferences = async (userId: string, params: SearchParams) => {
  const path = `${process.env.API_REPORTS_USERS!}/${userId}/preferences`;
  return await serverFetch<UserPreferencesType>({ path, params });
};

export const getOrderPreferences = async (userId: string, orderId: string, params: SearchParams) => {
  const path = `${process.env.API_REPORTS_USERS!}/${userId}/orders/${orderId}/preferences`;
  return await serverFetch<OrderPreferencesType>({ path, params });
}

export const getOrdersSummary = async (params: SearchParams) => {
  const path = process.env.API_REPORTS_ORDERS_SUMMARY!;
  return await serverFetch<OrderType[]>({ path, params });
}

export const getProducts = async (params: SearchParams) => {
  const path = process.env.API_REPORTS_PRODUCTS_TOP!;
  return await serverFetch<ProductType[]>({ path, params });
};

export const getProductOrders = async (productId: string, params: SearchParams) => {
  const path = `${process.env.API_REPORTS_PRODUCTS!}/${productId}/orders`;
  return await serverFetch<ProductOrdersType>({ path, params });
}

export const getUsersSearch = async (state: UsersSearchState, formData: FormData) => {
  const name = String(formData.get("name") ?? "").trim();
  if (name.length < 3) {
    return { ...state, query: name, users: [] };
  }
  const path = process.env.API_REPORTS_USERS_SEARCH!;
  const users = await serverFetch<UserType[]>({ path, params: {...state.params, size: "5", name} });

  return { ...state, query: name, users };
}

export const getProductsSearch = async (state: ProductsSearchState, formData: FormData) => {
  const name = String(formData.get("name") ?? "").trim();
  if (name.length < 3) {
    return { ...state, query: name, products: [] };
  }
  const path = process.env.API_REPORTS_PRODUCTS_SEARCH!;
  const products = await serverFetch<ProductType[]>({ path, params: {...state.params, size: "5", name} });

  return { ...state, query: name, products };
}

export const exportUsersTop = async (params: SearchParams) => {
  const path = process.env.API_REPORTS_EXPORT_USERS_TOP!;
  return await serverFetchText({ path, params });
};